/**
 * Sanitizes the given order ID by replacing spaces with underscores.
 *
 * @param {string} orderId - The order ID to sanitize.
 * @return {string} The sanitized order ID by replacing spaces with _.
 */
export function sanitizeOrderId(orderId: string) {
  return orderId.replaceAll(' ', '_');
}
